module.exports = __webpack_public_path__ + "officialStatic/img/auth2.b25ec47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/auth2.jpg
// module id = jOjl
// module chunks = 0